<div class="z-10 ribbon ribbon-{{position}}" [ngClass]="color()">
  <span [ngClass]="spanColor()">
    <ng-content></ng-content>
  </span>
</div>